module.exports = __webpack_public_path__ + "static/img/1-1.ba8adf6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/13/eng/1-1.png
// module id = GM9c
// module chunks = 0